// Calendar dates ("YYYY-MM-DD") without time-zone surprises. See D-061.
//
// The database stores transaction, budget and recurring dates as plain
// calendar days (Postgres `date`). JavaScript has no such type, so two
// shortcuts go wrong:
//   - `new Date("2026-10-21")` is read as UTC midnight. West of UTC
//     (e.g. New York) that is the evening of the 20th, one day early.
//   - `new Date().toISOString().slice(0, 10)` is the UTC date. East of UTC
//     (e.g. Berlin, just after midnight) that is still yesterday.
// Use these helpers instead; they always work in the user's own time zone.

const pad = (n: number) => String(n).padStart(2, "0");

/** A Date's local calendar day as "YYYY-MM-DD". Defaults to today. */
export function toISODate(d: Date = new Date()): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Today's local calendar day as "YYYY-MM-DD". */
export function todayISO(): string {
  return toISODate(new Date());
}

/**
 * Read a "YYYY-MM-DD" string (or the date part of a longer one) as local
 * midnight of that day. Returns an invalid Date for anything else.
 */
export function parseLocalDate(iso: string | null | undefined): Date {
  const [y, m, d] = (iso || "").slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return new Date(NaN);
  return new Date(y, m - 1, d);
}
